const upload = function(event) {
  const formData = new FormData();
  const files = event.target.files;
  for (let i = 0; i < files.length; i++) {
    let index = files[i].name.lastIndexOf(".");
    let type = files[i].name.slice(index + 1, files[i].name.length);
    formData.append("file", files[i]);
    formData.append("from", type);
  }

  return formData;
};

export default upload;
